import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { CurrentTimezoneModel } from '../../shared/models/current-timezone.model';
import { CurrentMeetService } from '../../shared/services/current-meet.service';
import { AsyncPipe, DatePipe } from '@angular/common';
import { AliveDatePipe } from '../../shared/pipes/alive-date.pipe';
import { DateTime } from 'luxon';

@Component({
  selector: 'app-event-updated-at',
  imports: [AsyncPipe, AliveDatePipe],
  templateUrl: './event-updated-at.component.html',
  styleUrl: './event-updated-at.component.scss',
})
export class EventUpdatedAtComponent {
  @Input() dataPointType!: 'entry' | 'heat' | 'result' | 'flight' | 'section';
  @Input() date!: string;
  currentTimezone$!: Observable<CurrentTimezoneModel | null>;
  dataPointUpdatedAt: Map<string, string> = new Map<string, string>([
    ['entry', $localize`:@@updatedAt.entry:Entries last updated at:`],
    ['heat', $localize`:@@updatedAt.heat:Heats last updated at:`],
    ['result', $localize`:@@updatedAt.result:Results last updated at:`],
    ['flight', $localize`:@@updatedAt.flight:Flights last updated at:`],
    ['section', $localize`:@@updatedAt.section:Sections last updated at:`],
  ]);
  updatedAtString = '';

  constructor(public currentMeetService: CurrentMeetService) {
    this.currentTimezone$ = this.currentMeetService.updateCurrentTimezone;
  }

  ngOnInit() {
    this.updatedAtString = this.dataPointUpdatedAt.get(this.dataPointType) || '';
  }

  protected readonly DateTime = DateTime;
}
